<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">Document Outbox</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <v-col
                cols="12"
            >
                <v-btn
                    text
                    @click="AddNew"
                >
                    <v-icon class="mr-2">mdi-plus</v-icon>New Document
                </v-btn>
            </v-col>

            <v-col
                cols="12"
            >
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        class="elevation-6"
                        fixed-header
                    >
                        <template v-slot:item.numapproved="{ item }">
                            <v-btn
                                small
                                rounded
                                @click="ViewApprovers(item.approvers, item.notes)"
                            >
                                {{ item.approvers.filter(x => {
                                    return parseInt(x.status) == 1
                                }).length }}/{{ item.approvers.length }}
                            </v-btn>
                        </template>

                        <template v-slot:item.dateadded="{ item }">
                            {{ MomentDate(item.dateadded) }}
                        </template>

                        <template v-slot:item.status="{ item }">
                            <template v-if="item.expired && parseInt(item.status) == 0">
                                Expired
                            </template>
                            <template v-else>
                                <template v-if="parseInt(item.status) == 0">
                                    Processing
                                </template>
                                <template v-else>
                                    <template v-if="item.notes">
                                        <template v-if="item.notes.filter(x => x.action.toString() == 'disapprove').length > 0">
                                            Disapproved
                                        </template>
                                        <template v-else>
                                            Approved
                                        </template>
                                    </template>
                                    <template v-else>
                                        Approved
                                    </template>
                                </template>
                            </template>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-btn
                                text
                                color="blue darken-2"
                                @click="ViewPDF(item)"
                            >
                                <v-icon>mdi-file-pdf-outline</v-icon>
                            </v-btn>

                            <v-btn
                                text
                                color="orange darken-2"
                                @click="DownloadDocumentFile(item)"
                            >
                                <v-icon>mdi-cloud-download-outline</v-icon>
                            </v-btn>

                            <template v-if="parseInt(item.status) == 0 && item.approvers.filter(x => parseInt(x.status) == 1).length == 0">
                                <v-btn
                                    text
                                    color="green darken-2"
                                    @click="EditDocument(item)"
                                >
                                    <v-icon>mdi-lead-pencil</v-icon>
                                </v-btn>

                                <v-btn
                                    text
                                    color="red darken-2"
                                    @click="DeleteDocument(item._id.toString())"
                                >
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                            </template>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            
            <v-col
                cols="12"
            >
                <v-btn
                    small
                    text
                    @click="getDataFromApiSync"
                >
                    <v-icon class="mr-2" small>mdi-refresh</v-icon>Refresh List
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog
            v-model="approverlist"
            scrollable
            max-width="1080"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-account-check-outline mr-2"></i>Recipients</v-card-title>
                
                <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        Approver
                                    </th>
                                    <th class="text-center">
                                        Status
                                    </th>
                                    <th class="text-center">
                                        Date Read/Approved
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(approver, i) in currentapprovers">
                                    <tr
                                        :key="`approver-key-${i}`"
                                    >
                                        <td>
                                            <span v-if="approver.approverdetails.ch_jobtitle.toString().length > 0">({{approver.approverdetails.ch_jobtitle.toString()}}) </span>{{approver.approverdetails.fullname_format2.toString()}}
                                        </td>
                                        <td>
                                            <template v-if="parseInt(approver.status) == 1">
                                                <template v-if="approver.approved">
                                                    Approved
                                                </template>
                                                <template v-else>
                                                    Disapproved
                                                </template>
                                            </template>
                                            <template v-else>
                                                Not yet read
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="approver.dateapproved">
                                                {{ MomentDate(parseInt(approver.dateapproved)) }}
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>
                    <v-btn 
                        text
                        dark
                        @click="approverlist = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="fileform"
            scrollable
            max-width="800"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-document-edit-outline mr-2"></i>Document Details</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-row dense>
                        <v-col
                            cols="12"
                            class="mt-3"
                        >
                            <v-text-field
                                v-model="file.docname"
                                label="Document Name"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            class="d-none"
                        >
                            <v-text-field
                                v-model="file.metadata"
                                label="Metadata"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-textarea
                                v-model="file.description"
                                label="Description"
                                outlined
                                dense
                            ></v-textarea>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-menu
                                v-model="datepickermenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="file.dateduration"
                                    label="Document Duration"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="file.dateduration"
                                    @input="datepickermenu = false"
                                    :min="datepickermenumin"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-combobox
                                v-model="file.keywords"
                                :items="[]"
                                chips
                                label="Keywords"
                                multiple
                                solo
                                dense
                            >
                                <template v-slot:selection="{ attrs, item, select, selected }">
                                <v-chip
                                    v-bind="attrs"
                                    :input-value="selected"
                                    close
                                    @click="select"
                                    @click:close="RemoveKeyword(item)"
                                >
                                    <strong>{{ item }}</strong>
                                </v-chip>
                                </template>
                            </v-combobox>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-file-input
                                v-model="file.docfile"
                                accept="application/pdf"
                                label="File Attachment"
                                hint="PDF file only"
                                persistent-hint
                                show-size
                                counter
                                @change="FileAttachment"
                            >
                                <template v-slot:selection="{ text }">
                                    <v-chip
                                        small
                                        label
                                        color="primary"
                                    >
                                        {{ text }}
                                    </v-chip>
                                </template>
                            </v-file-input>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-select
                                v-model="approverfilter"
                                :items="approverfilters"
                                item-text="text"
                                item-value="value"
                                hint="You can add recipients by division, citizen group or by citizen name search"
                                persistent-hint
                            ></v-select>
                        </v-col>

                        <template v-if="parseInt(approverfilter) == 2">
                            <v-col
                                cols="12"
                            >
                                <v-autocomplete
                                    v-model="citizensearched"
                                    :items="citizenitems"
                                    :loading="citizenloading"
                                    :search-input.sync="citizensearch"
                                    item-text="fullname_format1"
                                    item-value="_id"
                                    label="Search Citizen"
                                    placeholder="Start typing to Search"
                                    prepend-icon="mdi-database-search"
                                    return-object
                                    append-icon="mdi-plus"
                                    @click:append="AddApproverFromCitizenSearch"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </template>

                        <template v-else-if="parseInt(approverfilter) == 1">
                            <v-col
                                cols="12"
                                lg="10"
                                md="10"
                            >
                                <v-autocomplete
                                    :items="citizengroups"
                                    item-text="text"
                                    item-value="value"
                                    v-model="citizengroup"
                                    label="Select Citizen Group"
                                    return-object
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col
                                cols="12"
                                md="2"
                                lg="2"
                            >
                                <v-btn
                                    text
                                    @click="AddApproverFromGroup"
                                >
                                    Add
                                </v-btn>
                            </v-col>
                        </template>

                        <template v-else-if="parseInt(approverfilter) == 0">
                            <v-col
                                cols="12"
                                md="5"
                                lg="5"
                            >
                                <!-- <v-suggest
                                    :data="divisionsearch"
                                    placeholder="Select Division"
                                    style="width: 100%;"
                                    v-model="search.division"
                                    @values="SelectedDivision"
                                ></v-suggest> -->

                                <v-autocomplete
                                    :items="divisionsearch"
                                    item-text="name"
                                    item-value="id"
                                    v-model="search.division"
                                    label="Select Division"
                                    @input="SelectedDivision"
                                    return-object
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col
                                cols="12"
                                md="5"
                                lg="5"
                            >
                                <!-- <v-suggest
                                    :data="employeesearch"
                                    placeholder="Select Employee"
                                    style="width: 100%;"
                                    v-model="search.employee"
                                    :disabled="employeedisabled"
                                    @values="SelectedEmployee"
                                ></v-suggest> -->

                                <v-autocomplete
                                    :items="employeesearch"
                                    item-text="name"
                                    item-value="id"
                                    v-model="search.employee"
                                    label="Select Employee"
                                    :disabled="employeedisabled"
                                    return-object
                                    @input="SelectedEmployee"
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col
                                cols="12"
                                md="2"
                                lg="2"
                            >
                                <v-btn
                                    text
                                    @click="AddApprover"
                                >
                                    Add
                                </v-btn>
                            </v-col>
                        </template>

                        <v-col
                            cols="12"
                            v-if="approvers.length > 0"
                        >
                            <v-alert
                                type="info"
                                dense
                            >
                                Recipients
                            </v-alert>
                        </v-col>

                        <v-col
                            cols="12"
                            v-if="approvers.length > 0"
                        >
                            <v-data-table
                                :headers="approverheaders"
                                :items="approvers"
                                :items-per-page="5"
                                class="elevation-6"
                            >
                                <template v-slot:item.actions="{ item }">
                                    <v-btn
                                        text
                                        color="red darken-2"
                                        @click="RemoveApprover(item)"
                                    >
                                        <v-icon>mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </template>

                                <!-- <template v-slot:item.approver="{ item }">
                                    <div class="align-center justify-center">
                                        <v-checkbox
                                            v-model="item.approver"
                                            color="red darken-2"
                                            class="d-inline-flex"
                                        ></v-checkbox>
                                    </div>
                                </template> -->
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        dark
                        color="red darker-4"
                        @click="fileform = false"
                    >
                        Close
                    </v-btn>

                    <v-btn
                        dark
                        color="green darker-4"
                        @click="SaveChanges"
                    >
                        Save Changes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="pdf.show"
            scrollable
            max-width="1080"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-pdf-outline mr-2"></i>PDF Viewer</v-card-title>

                <v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                            class="mr-2"
                            text
                            :disabled="pdf.page == 1"
                            @click="pdf.page = 1"
                        >
                            First
                        </v-btn>
                        <v-btn
                            class="mr-2"
                            text
                            :disabled="pdf.page == 1"
                            @click="pdf.page--"
                        >
                            Prev
                        </v-btn>
                        Page <input v-model.number="pdf.page" type="number" style="width: 3.5em" class="mx-2 text-center" /> of {{ pdf.pageCount }}
                        <v-btn
                            class="ml-2"
                            text
                            :disabled="pdf.page == pdf.pageCount"
                            @click="pdf.page++"
                        >
                            Next
                        </v-btn>
                        <v-btn
                            class="ml-2"
                            text
                            :disabled="pdf.page == pdf.pageCount"
                            @click="pdf.page = pdf.pageCount"
                        >
                            Last
                        </v-btn>
                    </v-card-actions>

                    <v-row dense>
                        <v-col
                            :cols="currentfile.notes && currentfile.notes.length > 0 ? 8 : 12"
                        >
                            <PDF
                                v-if="pdf.show"
                                :src="pdf.media"
                                @num-pages="pdf.pageCount = $event"
                                @page-loaded="pdf.currentPage = $event"
                                :page="pdf.page"
                                ref="pdffile"
                            ></PDF>
                        </v-col>
                        <v-col
                            :cols="currentfile.notes && currentfile.notes.length > 0 ? 4 : 0"
                            v-if="currentfile.notes && currentfile.notes.length > 0"
                        >
                            <v-alert
                                type="info"
                                dense
                            >
                                Notes
                            </v-alert>
                            <perfect-scrollbar>
                                <template v-for="(note, k) in currentfile.notes">
                                    <v-card
                                        :key="`note-${k}`"
                                        class="mx-auto text-wrap mb-3"
                                        dark
                                        :color="note.action == 'approve' ? '#59981A' : '#F51720'"
                                        elevation="6"
                                    >
                                        <v-card-text class="text-subtitle-2 font-weight-bold" v-html="nl2br(note.notes)">
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-list-item class="grow">
                                                <v-list-item-avatar color="grey darken-3">
                                                    <v-img
                                                        class="elevation-6"
                                                        alt=""
                                                        :src="ApproverAvatar(note.user[0].imgUrl.toString())"
                                                    ></v-img>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                    <v-list-item-title>{{ note.user[0].fullname_format1 }}</v-list-item-title>
                                                    <v-list-item-subtitle>{{ MomentDate(note.dateadded) }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </perfect-scrollbar>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                        text
                        dark
                        @click="$refs.pdffile.print()"
                    >
                        Print
                    </v-btn> -->

                    <v-btn 
                        text
                        dark
                        @click="pdf.show = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment"
// import { Suggest } from 'v-suggest'
import PDF from 'vue-pdf'

export default {
    name: 'documentapproving',
    props: ['CheckIfLoggedInInternal'],
    components: {
        // 'v-suggest': Suggest,
        PDF,
    },
    metaInfo: {
        title: 'Digital Tuguegarao - Document Approving'
    },
    data() {
        return {
            approverfilter: 0,
            approverfilters: [
                {
                    text: 'Select Division',
                    value: 0,
                },
                {
                    text: 'Select Citizen Group',
                    value: 1,
                },
                {
                    text: 'Search Citizen',
                    value: 2,
                },
            ],
            citizengroup: null,
            citizengroups: [],
            citizensearched: null,
            citizensearch: null,
            citizenitems: [],
            citizenloading: false,
            datepickermenumin: new Date().toISOString().substr(0, 10),
            datepickermenu: false,
            approverlist: false,
            currentapprovers: [],
            pdf: {
                show: false,
                media: [],
                currentPage: 0,
                pageCount: 0,
                page: 1,
            },
            recordid: '',
            overlay: false,
            approverheaders: [{
                text: 'Employee Name',
                value: 'name',
                align: 'center',
                sortable: false,
            }, {
                text: 'Division',
                value: 'divisionname',
                align: 'center',
                sortable: false,
            },
            // {
            //     text: 'Approver',
            //     value: 'approver',
            //     align: 'center',
            //     sortable: false,
            // },
            {
                text: 'Actions',
                value: 'actions',
                align: 'center',
                sortable: false,
            }],
            approvers: [],
            currentfile: {},
            search: {
                division: {},
                employee: {},
                employeedetails: {},
                divisiondetails: {},
            },
            employeedisabled: false,
            employeesearch: [],
            divisionsearch: [],
            divisions: [],
            fileform: false,
            file: {
                docname: '',
                docfile: undefined,
                docfiledata: '',
                approvers: [],
                metadata: '',
                description: '',
                keywords: [],
                dateduration: new Date().toISOString().substr(0, 10),
            },
            loading: false,
            items: [],
            total: 0,
            headers: [
                {
                    text: 'Document Name',
                    sortable: false,
                    value: 'docname',
                    align: 'center',
                },
                {
                    text: '# of Recipients',
                    sortable: false,
                    value: 'numapproved',
                    align: 'center',
                },
                {
                    text: 'Status',
                    sortable: false,
                    value: 'status',
                    align: 'center',
                },
                {
                    text: 'Document Date',
                    sortable: false,
                    value: 'dateadded',
                    align: 'center',
                },
                {
                    text: 'Actions',
                    sortable: false,
                    value: 'actions',
                    align: 'center',
                }
            ],
            options: {},
            employeeajax: null,
            employeecache: [],
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.total = parseInt(data.total)
                    })
            },
            deep: true,
        },
        citizensearch(val) {
            if(!val) return

            if (this.citizenloading) return

            this.citizenloading = true

            axios({
                method: 'POST',
                url: `${this.domain}/crm_lgu_citizen_search`,
                data: {
                    search: val.toString()
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.citizenitems = response.data.items
                    }
                })
                .catch(() => {
                    this.citizenitems = []
                })
                .finally(() => {
                    this.citizenloading = false
                })
        }
    },
    methods: {
        AddApproverFromGroup() {
            if(this.citizengroup){
                this.$emit('ol', true)

                axios({
                    method: 'post',
                    url: `${this.domain}/crm_citizen_group_load_approvers`,
                    data: {
                        _id: this.citizengroup.value.toString(),
                    }
                })
                    .then(response => {
                        this.$emit('ol', false)

                        if(response.data.response){
                            const div = this.$jwt.decode(response.data.approvers, this.jwtsecret)

                            this.citizengroup = null

                            div.approvers.forEach(x => {
                                const checkapp = this.approvers.filter(e => {
                                    return e.id.toString() == x._id.toString()
                                })

                                const divd = this.divisions.filter(e => {
                                    return x.ch_divisions[0].toString() == e.text.toString()
                                })

                                if(checkapp.length == 0 && divd.length > 0){
                                    this.approvers.push({
                                        id: x._id.toString(),
                                        name: x.fullname_format1.toString(),
                                        division: divd[0].value.toString(),
                                        divisionname: divd[0].text.toString(),
                                        approver: false,
                                    })
                                }
                            })
                        } else{
                            this.$emit('snackbar', {
                                variant: 'error',
                                message: response.data.message
                            })
                        }
                    })
                    .catch(() => {
                        this.$emit('ol', false)

                        this.$emit('snackbar', {
                            variant: 'error',
                            message: 'Something went wrong... Try again...'
                        })
                    })
            }
        },
        NotYetRead() {
            const reader = this.currentfile.approvers.filter(x => {
                return parseInt(x.status) == 1 && x.approver.toString() == this.citizen._id.toString()
            })

            return reader.length == 0
        },
        nl2br (str, is_xhtml) {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
        ApproverAvatar(avatar) {
            return avatar && avatar.toString().length > 0 ? `${this.domain}/serve/staticfiles/${avatar.replace('public/files/', '')}` : 'https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light'
        },
        ViewApprovers(approvers, notes) {
            this.currentapprovers = approvers.map(x => {
                if(!notes){
                    return x
                }

                x.approved = notes.filter(e => {
                    return x.approver.toString() == e.userid.toString() && e.action.toString() == 'disapprove'
                }).length == 0

                return x
            })

            this.approverlist = true
        },
        RemoveKeyword (item) {
            this.file.keywords.splice(this.file.keywords.indexOf(item), 1)
            this.file.keywords = [...this.file.keywords]
        },
        DownloadDocumentFile(item) {
            // alert(item._id.toString())
            window.location = `${this.domain}/tugue-doc-file/${item._id.toString()}`
        },
        ViewPDF(attachment) {
            let pdf = 'https://cdn.vuetifyjs.com/images/cards/docks.jpg'

            if(attachment.toString().length > 0){
                pdf = `${this.domain}/serve/staticfiles/${attachment.file.toString().replace('public/files/', '')}`
            }

            this.pdf.pageCount = 0
            this.pdf.page = 1
            this.pdf.media = pdf
            this.pdf.show = true

            this.currentfile = attachment
        },
        DeleteDocument(_id) {
            this.$emit('ol', true)

            axios({
                method: 'post',
                url: `${this.domain}/crm_internal_document_delete`,
                data: {
                    _id,
                }
            })
                .then(response => {
                    this.$emit('ol', false)

                    if(response.data.response){
                        this.$emit('snackbar', {
                            variant: 'success',
                            message: 'Document has been deleted',
                        })

                        this.getDataFromApiSync()
                    } else{
                        this.$emit('snackbar', {
                            variant: 'warning',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.$emit('ol', false)

                    this.$emit('snackbar', {
                        variant: 'error',
                        message: 'Something went wrong... Try again...'
                    })
                })
        },
        EditDocument(item) {
            // console.log(item)
            this.AddNew()

            // this.file.
            this.recordid = item._id.toString()
            this.approvers = item.approvers.map(x => {
                return {
                    id: x.approver.toString(),
                    name: x.approverdetails.fullname_format2.toString(),
                    division: x.division.toString(),
                    divisionname: x.divisiondetails.division.toString(),
                    approver: !x.reader
                }
            })
            this.file.docname = item.docname.toString()
            this.file.metadata = item.metadata.toString()
            this.file.description = item.description.toString()
            this.file.keywords = item.keywords

            this.file.dateduration = item.dateduration ? moment(parseInt(item.dateduration) * 1000).toDate().toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10)

            this.employeesearch = []
        },
        SaveChanges() {
            // console.log(this.file)

            if(
                (this.recordid.toString().length == 0 && this.file.docname.toString().length > 0 && this.file.docfiledata.toString().length > 0 && this.approvers.length > 0)
                || (this.recordid.toString().length > 0 && this.file.docname.toString().length > 0 && this.approvers.length > 0)
            ){
                this.$emit('ol', true)

                axios({
                    method: 'post',
                    url: `${this.domain}/crm_internal_document_process`,
                    data: {
                        docname: this.file.docname.toString(),
                        file: this.file.docfiledata.toString(),
                        approvers: this.approvers,
                        userid: this.citizen._id.toString(),
                        recordid: this.recordid.toString(),
                        metadata: '',
                        description: this.file.description || '',
                        keywords: this.file.keywords,
                        dateduration: this.file.dateduration,
                    }
                })
                    .then(response => {
                        this.$emit('ol', false)

                        if(response.data.response){
                            this.fileform = false

                            this.$emit('snackbar', {
                                variant: 'success',
                                message: 'Document has been added for approval',
                            })

                            this.getDataFromApiSync()
                        } else{
                            this.$emit('snackbar', {
                                variant: 'warning',
                                message: response.data.message.toString(),
                            })
                        }
                    })
                    .catch(() => {
                        this.$emit('ol', false)

                        this.$emit('snackbar', {
                            variant: 'error',
                            message: 'Something went wrong... Try again...'
                        })
                    })
            }
        },
        RemoveApprover(item) {
            this.approvers.forEach((x, i) => {
                if(x.id.toString() == item.id.toString()){
                    this.approvers.splice(i, 1)
                }
            })
        },
        AddApproverFromCitizenSearch() {
            if(this.citizensearched){
                const s = this.approvers.filter(x => {
                    return x.id.toString() == this.citizensearched._id.toString()
                })

                const div = this.divisions.filter(x => {
                    return this.citizensearched.ch_divisions[0].toString() == x.text.toString()
                })

                if(s.length == 0 && div.length > 0){
                    this.approvers.push({
                        id: this.citizensearched._id.toString(),
                        name: this.citizensearched.fullname_format1.toString(),
                        division: div[0].value.toString(),
                        divisionname: div[0].text.toString(),
                        approver: false,
                    })
                    
                    this.citizenitems = []
                    this.citizensearched = null
                }
            }
        },
        async AddApprover() {
            // console.log(this.search.divisiondetails)
            // console.log(this.search.employeedetails)

            if(this.search.divisiondetails.id && this.search.divisiondetails.id.toString().length > 0){
                if(this.search.employeedetails.id && this.search.employeedetails.id.toString().length > 0){
                    const s = this.approvers.filter(x => {
                        return x.id.toString() == this.search.employeedetails.id.toString()
                    })

                    if(s.length == 0){
                        this.approvers.push({
                            id: this.search.employeedetails.id.toString(),
                            name: this.search.employeedetails.name.toString(),
                            division: this.search.divisiondetails.id.toString(),
                            divisionname: this.search.divisiondetails.name.toString(),
                            approver: false,
                        })

                        this.search.employeedetails = {}
                        this.search.employee = ''
                    }
                } else{
                    for await (const es of this.employeesearch) {
                        const s = this.approvers.filter(x => {
                            return x.id.toString() == es.id.toString()
                        })

                        if(s.length == 0){
                            this.approvers.push({
                                id: es.id.toString(),
                                name: es.name.toString(),
                                division: this.search.divisiondetails.id.toString(),
                                divisionname: this.search.divisiondetails.name.toString(),
                                approver: false,
                            })
                        }
                    }

                    this.search.employeedetails = {}
                    this.search.employee = ''
                }
            }
        },
        SelectedEmployee() {
            // this.search.employeedetails = value
            // console.log(this.search.employee)
            this.search.employeedetails = _.cloneDeep(this.search.employee)
        },
        SelectedDivision() {
            const value = this.search.division

            this.employeesearch = []
            this.search.employeedetails = {}
            this.search.divisiondetails = {}

            // console.log(value)

            if(value.name.toString().length > 0){
                const div = this.divisions.filter(x => {
                    return x.value.toString() == value.id.toString()
                })

                if(div.length == 0){
                    this.employeedisabled = false

                    return
                }

                // check cache
                const cache = this.employeecache.filter(x => {
                    return x.id.toString() == value.id.toString()
                })

                this.search.divisiondetails = value

                if(cache.length > 0){
                    this.employeesearch = _.cloneDeep(cache[0].data)

                    return
                }

                this.employeedisabled = true

                axios({
                    method: 'post',
                    url: `${this.domain}/crm_ch_employees_by_division`,
                    data: {
                        divid: value.id.toString(),
                        divname: value.name.toString(),
                    }
                })
                    .then(response => {
                        this.employeedisabled = false

                        if(response.data.response){
                            const emp = this.$jwt.decode(response.data.employees)

                            this.employeesearch = emp.employees.map(x => {
                                return  {
                                    id: x._id.toString(),
                                    name: (x.ch_jobtitle && x.ch_jobtitle.toString().length > 0 ? `(${x.ch_jobtitle.toString()}) ` : ``) + x.fullname_format2.toString(),
                                }
                            })

                            this.employeecache.push({
                                id: value.id.toString(),
                                data: this.employeesearch,
                            })
                        }
                    })
                    .catch(() => {
                        this.employeedisabled = false
                    })
            }
        },
        CitizenGroups() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_citizen_groups_select`,
                data: {
                    rand: Math.random(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        const div = this.$jwt.decode(response.data.citizengroups, this.jwtsecret)
                        this.citizengroups = div.citizengroups.map(x => {
                            return {
                                text: x.name.toString(),
                                value: x._id.toString(),
                            }
                        })
                    }
                })
                .catch(() => {

                })
        },
        Divisions() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_ch_divisions`,
                data: {
                    rand: Math.random(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        const div = this.$jwt.decode(response.data.divisions)
                        this.divisions = div.divisions.map(x => {
                            return {
                                text: x.division.toString(),
                                value: x._id.toString(),
                            }
                        })
                        this.divisionsearch = div.divisions.map(x => {
                            return {
                                name: x.division.toString(),
                                id: x._id.toString(),
                            }
                        })
                    }
                })
                .catch(() => {

                })
        },
        async FileAttachment(_file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            this.file.docfiledata = ''

            toBase64(_file).then(mfile => {
                this.file.docfiledata = mfile
            })
        },
        AddNew() {
            this.recordid = ''

            this.file = {
                docname: '',
                docfile: undefined,
                docfiledata: '',
                approvers: [],
                metadata: '',
                description: '',
                keywords: [],
                dateduration: new Date().toISOString().substr(0, 10),
            }

            this.search = {
                division: {},
                employee: {},
                employeedetails: {},
                divisiondetails: {},
            }

            this.approvers = []

            this.fileform = true
        },
        getDataFromApiSync() {
            this.getDataFromApi()
                .then(data => {
                    this.items = data.items
                    this.total = parseInt(data.total)
                })
        },
        getDataFromApi() {
            this.loading = true

            return new Promise((resolve) => {
                const { page, itemsPerPage } = this.options
                const start_row = (parseInt(page) - 1) * parseInt(itemsPerPage)

                if(this.employeeajax){
                    this.employeeajax.cancel()
                }

                this.employeeajax = axios.CancelToken.source()

                axios({
                    url: `${this.domain}/crm_document_approving`,
                    method: 'POST',
                    data: {
                        start_row,
                        limit: itemsPerPage,
                        userid: this.citizen._id.toString(),
                    },
                    cancelToken: this.employeeajax.token
                })
                    .then(response => {
                        this.loading = false

                        if(response.data.response){
                            setTimeout(() => {
                                const items = this.$jwt.decode(response.data.items, this.jwtsecret)

                                // console.log(items.items)

                                resolve({
                                    items: items.items,
                                    total: response.data.total
                                })
                            }, 500)
                        } else{
                            setTimeout(() => {
                                resolve({
                                    items: [],
                                    total: 0
                                })
                            }, 500)
                        }
                    }).catch(function(err) {
                        console.log(err)

                        resolve({
                            items: [],
                            total: 0
                        })
                    })
            })
        },
        MomentDate(dt) {
            return moment(parseInt(dt) * 1000).format('MMM D, YYYY h:mm A')
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        if(this.citizen.ch_employee == false){
            this.$router.push({
                name: 'login'
            }).catch(() => {})
        }

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.Divisions()
        this.CitizenGroups()
    }
}
</script>

<style scoped>
.ps {
  height: 800px;
}
</style>